module.exports = __webpack_public_path__ + "img/TZS09386.b21559c4.jpeg";